import { uuidv4 } from '@wppopen/components-library'
import { WppListItem } from '@wppopen/components-library-react'

const renderEmptyState = (label: string, testId: string) => (
  <WppListItem value="404" data-testid={testId} disabled key={uuidv4()}>
    <p slot="label">{label}</p>
  </WppListItem>
)

const renderSelectItem = (id: string, label: string, testId: string) => (
  <WppListItem key={id} value={id} data-testid={testId}>
    <p slot="label">{label}</p>
  </WppListItem>
)

export { renderEmptyState, renderSelectItem }
